// ─────────────────────────────────────────────────────────────
// Utilitaires de validité d'un thème Zifek.
// Un thème « complet » (généré par l'IA ou importé) possède une vraie
// feuille de style et/ou des pages qui utilisent les balises de blocs
// dynamiques. Un thème « échantillon » (design par défaut) a une
// feuille de style quasi vide et des pages statiques : dans ce cas on
// retombe sur la vitrine dynamique intégrée (qui reflète le vrai logo,
// la bannière, les produits et la charte du marchand).
// ─────────────────────────────────────────────────────────────

/** Seuil (en caractères) au-dessus duquel une feuille de style est jugée « réelle ». */
const STYLED_MIN_LENGTH = 400;

/** La feuille de style du thème est-elle substantielle ? */
export function isStyledTheme(stylesheet: string | null | undefined): boolean {
  return Boolean(stylesheet && stylesheet.trim().length > STYLED_MIN_LENGTH);
}

const BLOCK_TAG_RE =
  /\{\{\s*(products|services|featured_products|hero_banners|gallery|testimonials|faq|blog_posts|portfolio|team|partners|stats|hebergements|marketplace_products|marketplace_sellers|marketplace_search|marketplace_categories|contact_form|booking_form)\b/i;

/** La page contient-elle au moins une balise de bloc dynamique Zifek ? */
export function hasDynamicBlockTag(content: string | null | undefined): boolean {
  return Boolean(content && BLOCK_TAG_RE.test(content));
}

/**
 * La page de thème est-elle réellement exploitable (dynamique ou
 * appuyée sur une vraie feuille de style) ?
 */
export function isUsableThemePage(
  content: string | null | undefined,
  stylesheet: string | null | undefined,
): boolean {
  return hasDynamicBlockTag(content) || isStyledTheme(stylesheet);
}